import { WorkflowApi } from '@calm/evexia-web-sdk/generated/lib/api/workflow-api';
import { AxiosInstance } from 'axios';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of an `WorkflowApi`
 * @param accessToken
 * @returns
 */
export default function createWorkflowApi(
    accessToken: () => Promise<string>,
    client?: AxiosInstance
) {
    return createApi(WorkflowApi, accessToken, undefined, client);
}
